var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show_modelos)?_c('table-list',{ref:"table-list",attrs:{"actions":"select"},on:{"selected":_vm.selectedModelo}}):_c('dados-contrapartida',{ref:"dados",model:{value:(_vm.contrapartida),callback:function ($$v) {_vm.contrapartida=$$v},expression:"contrapartida"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }